import axios from 'axios';
import { api, getApiKeyFromLocalStorage } from './apiClient';
import { getEndpoints } from './endpointService';

export const validateApiKey = async (key) => {
  try {
    const apiKey = key || getApiKeyFromLocalStorage();
    if (!apiKey) {
      throw new Error('API key is missing');
    }

    const response = await api.post('/key/validate', { key: apiKey });

    if (response.status !== 200 || !response.data.data.is_valid) {
      console.error('Invalid API key');
      return false;
    }

    return response.data.data;
  } catch (error) {
    console.error('Validation error:', error);
    return false;
  }
};

export const validateApiKeyWithMultipleEndpoints = async (key) => {
  const errors = [];
  
  try {
    const endpoints = await getEndpoints();
    
    for (const endpoint of endpoints) {
      try {
        const api = axios.create({
          baseURL: `https://${endpoint}/api`,
          headers: {
            'Content-Type': 'application/json',
          }
        });

        const response = await api.post('/key/validate', { key });

        if (response.status === 200 && response.data.data.is_valid) {
          return { success: true, endpoint, data: response.data.data };
        }
      } catch (error) {
        errors.push(`${endpoint}: ${error.message}`);
      }
    }
  } catch (endpointError) {
    console.error('Failed to fetch endpoints:', endpointError);
    errors.push('Failed to fetch available endpoints');
  }
  
  return { success: false, errors };
};

export const validateApiKeyOnEndpoint = async (apiKey, endpoint) => {
  try {
    const api = axios.create({
      baseURL: `https://${endpoint}/api`,
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 2000
    });

    const response = await api.post('/key/validate', { key: apiKey });

    if (response.status === 200 && response.data.data.is_valid) {
      return { 
        success: true, 
        data: response.data.data 
      };
    } else {
      return { 
        success: false, 
        error: 'API Key invalid.' 
      };
    }
  } catch (error) {
    if (error.response && error.response.status === 500 && 
        error.response.data && error.response.data.error && 
        error.response.data.error.includes('no rows in result set')) {
      return { 
        success: false, 
        error: 'API Key invalid.' 
      };
    }
    
    if (error.code === 'ECONNREFUSED' || error.code === 'ETIMEDOUT' || error.code === 'ENETUNREACH' ||
        (error.response && error.response.status >= 500)) {
      return { 
        success: false, 
        error: 'Endpoint unavailable – contact your software provider.' 
      };
    }
    
    if (error.response && (error.response.status === 401 || error.response.status === 403 || error.response.status === 400)) {
      return { 
        success: false, 
        error: 'API Key invalid.' 
      };
    }
    
    return { 
      success: false, 
      error: 'Endpoint unavailable – contact your software provider.' 
    };
  }
};

